export const COMPANY_RURAL_API_INTERNAL_CODS = {
  16000: "Não é possível inativar o estabelecimento rural principal!",
  16001: "A inscrição estadual informada já está em uso!",
  16003: "Estabelecimento rural não encontrado!",
  16004: "Estabelecimento rural não encontrado!",
  16005: "É necessário que haja pelo menos um estabelecimento rural principal.",
  50010: "Erro ao manipular o estabelecimento rural!",
  50011: "Erro ao manipular o estabelecimento rural!",
  50020: "Erro ao manipular o estabelecimento rural!",
  50021: "Erro ao manipular o estabelecimento rural!",
  50030: "Erro ao manipular o estabelecimento rural!",
  50031: "Erro ao manipular o estabelecimento rural!",
  50040: "Erro ao manipular o estabelecimento rural!",
  50041: "Erro ao manipular o estabelecimento rural!",
  50050: "Erro ao manipular o estabelecimento rural!",
  50051: "Erro ao manipular o estabelecimento rural!",
  50060: "Erro ao manipular o estabelecimento rural!",
  50061: "Erro ao manipular o estabelecimento rural!",
};
